var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvScales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7239 39C75.7239 59.1562 59.3682 75.5 39.1876 75.5C19.007 75.5 2.65137 59.1562 2.65137 39C2.65137 18.8438 19.007 2.5 39.1876 2.5C59.3682 2.5 75.7239 18.8438 75.7239 39Z",
    fill: "white",
    stroke: "#F3F4F6",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5408 32.25C44.5172 25.9711 42.1029 21.5625 39.2933 21.5625C36.4837 21.5625 34.0694 25.9711 33.0458 32.25H45.5408ZM32.5163 39C32.5163 40.5609 32.601 42.0586 32.7493 43.5H45.8302C45.9785 42.0586 46.0632 40.5609 46.0632 39C46.0632 37.4391 45.9785 35.9414 45.8302 34.5H32.7493C32.601 35.9414 32.5163 37.4391 32.5163 39ZM55.438 32.25C53.419 27.4758 49.3316 23.7844 44.2842 22.2937C46.0067 24.6703 47.1927 28.2492 47.8139 32.25H55.438ZM34.2953 22.2937C29.2549 23.7844 25.1605 27.4758 23.1486 32.25H30.7727C31.3868 28.2492 32.5728 24.6703 34.2953 22.2937ZM56.1933 34.5H48.0963C48.2445 35.9766 48.3292 37.4883 48.3292 39C48.3292 40.5117 48.2445 42.0234 48.0963 43.5H56.1862C56.5745 42.0586 56.7934 40.5609 56.7934 39C56.7934 37.4391 56.5745 35.9414 56.1933 34.5ZM30.2573 39C30.2573 37.4883 30.342 35.9766 30.4903 34.5H22.3932C22.012 35.9414 21.7861 37.4391 21.7861 39C21.7861 40.5609 22.012 42.0586 22.3932 43.5H30.4832C30.342 42.0234 30.2573 40.5117 30.2573 39ZM33.0458 45.75C34.0694 52.0289 36.4837 56.4375 39.2933 56.4375C42.1029 56.4375 44.5172 52.0289 45.5408 45.75H33.0458ZM44.2913 55.7062C49.3316 54.2156 53.4261 50.5242 55.445 45.75H47.8209C47.1997 49.7508 46.0138 53.3297 44.2913 55.7062ZM23.1486 45.75C25.1676 50.5242 29.2549 54.2156 34.3023 55.7062C32.5798 53.3297 31.3939 49.7508 30.7727 45.75H23.1486Z",
    fill: "#803598"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.0143,
    height: 36,
    fill: "white",
    transform: "translate(21.7861 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvScales);
export default __webpack_public_path__ + "static/media/envScales.64364ecb342ca88d5cbf1f16e4b589df.svg";
export { ForwardRef as ReactComponent };